var breakpoints = {
  xs: 0,
  sm: 600,
  md: 768,
  lg: 960,
  xl: 1280
};

// See: https://material-ui.com/customization/palette/
var palette = {
  default: {
    light: '#8c98b2',
    main: '#16223E',
    contrastText: '#fff'
  },
  grey: {
    main: '#BCBCBC',
    transparent: 'rgba(140,152, 178, 0.10)'
  },
  primary: {
    main: '#00c0f3',
    contrastText: '#fff'
  },
  primaryAlt: {
    main: '#264A9A',
    dark: '#142855',
    contrastText: '#fff'
  },
  secondary: {
    main: '#ec008c',
    light: '#FABDE1',
    dark: '#aa0270'
  },
  secondaryAlt: {
    main: '#AA0270',
    dark: '#7E0052',
    contrastText: '#fff'
  },
  tertiary: {
    light: '#7bce5e',
    main: '#5BC236',
    dark: '#3f8725',
    contrastText: '#fff'
  },
  error: {
    main: '#dc3545'
  },
  warning: {
    main: '#ffc107'
  },
  info: {
    main: '#ec008c' // '#17a2b8',
  },

  success: {
    main: '#5BC236'
  },
  text: {
    primary: '#394869',
    secondary: '#627392'
  },
  action: {
    disabled: null,
    disabledBackground: null
  },
  background: {
    default: '#fff'
  }
};

// See: https://material-ui.com/customization/typography/
var typography = {
  fontFamily: '"Montserrat", sans-serif',
  button: {
    fontWeight: 700
  },
  fontWeightLight: 400,
  fontWeightRegular: 500,
  fontWeightMedium: 600,
  fontWeightBold: 600,
  size: {
    scale: function scale(factor) {
      return 0.25 * factor + "em";
    },
    small: '16px',
    medium: '18px',
    large: '22px'
  },
  h1: {
    fontSize: '2rem',
    fontWeight: 600
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 600
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 600
  },
  h4: {
    fontSize: '1.2rem',
    fontWeight: 600
  },
  h5: {
    fontSize: '1.1rem',
    fontWeight: 600
  },
  h6: {
    fontSize: '0.8rem',
    fontWeight: 600
  },
  subtitle1: {
    fontWeight: 600,
    fontSize: '1.2rem',
    lineHeight: '1.2em',
    textTransform: 'uppercase'
  }
};
var shadows = ['none', '0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)', '0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)', '0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)', '0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)', '0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)', '0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)', '0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)', '0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)', '0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)', '0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)', '0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)', '0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)', '0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)', '0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)', '0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)', '0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)', '0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)', '0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)', '0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)', '0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)', '0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)', '0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)', '0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)', '0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)'];
var shape = {
  borderRadius: 8
};
var spacing = function spacing(factor) {
  return 0.25 * factor + "rem";
};
var theme = {
  breakpoints: breakpoints,
  palette: palette,
  typography: typography,
  shadows: shadows,
  spacing: spacing,
  shape: shape
};
export var fontUrl = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap';
export default theme;